











import { Prop, Component, Vue } from "vue-property-decorator";
@Component
export default class SbbImageComponent extends Vue {
  @Prop({ required: true }) public reqSrc?: string;

  constructor() {
    super();
  }
}
